import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { DEV_HOSTS } from '../enum';

// Initializes and then sets page tracking based on location
export const useGaTracker = (trackingId: string | undefined) => {
    const location = useLocation();

    // Only initialize google analytics on deployed environments
    useEffect(() => {
        if (!trackingId) return;
        if (!Object.values(DEV_HOSTS).some((host) => window.location.href.includes(host))) return;
        ReactGA.initialize([
            {
                trackingId: trackingId,
            },
        ]);
    }, [trackingId]);

    // Subscribes to location changes and submits pageviews
    useEffect(() => {
        if (!ReactGA.isInitialized) return;

        // To track the first pageview upon load
        ReactGA.send(window.location.pathname + window.location.search);

        // To track the subsequent pageviews
        ReactGA.set({ page: location.pathname });
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);
};
